import Button from 'components/shared/Button';
import s from './Bundles.module.scss';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BundleCardProps {
  bundle: {
    id: string;
    name: string;
    image_url: string;
    price: number;
    service_bundle_items: Array<{
      services?: {
        id: string;
        name: string;
        service_pricing_duration?: Array<{
          price: number;
          duration?: number;
        }>;
      };
    }>;
  };
  salonId: string;
}

const BundleCard = ({ bundle, salonId }: BundleCardProps) => {
  const {t} = useTranslation() as any
  const navigate = useNavigate()
  return (
    <div key={bundle.id} className={s.bundles_card}>
      <img
        className={s.bundles_card_image}
        src={bundle.image_url}
        alt="bundle"
      />
      <div className={s.bundles_card_header}>
        <div className={s.bundles_card_header_title}>
          <div className={s.bundles_card_header_title}>
            {bundle.name}
          </div>
          <div className={s.bundles_card_header_subtitle}>
            {bundle.service_bundle_items
              .map(item => item.services?.name)
              .filter(Boolean)
              .join(' + ')}
          </div>
        </div>
        <Button darkGreen className={s.bundles_card_button} onClick={() => navigate(`/appointment-booking-spec/salon/${salonId}/bundle/${bundle?.id}`)}>
           {t('Book')}
        </Button>
      </div>
      <div className={s.bundles_card_price}>
        ﷼{bundle.price}
      </div>
    </div>
  );
};

export default BundleCard; 
